module.exports = __webpack_public_path__ + "img/201908-2.a6223af3.png";